var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticClass:"code-btn",attrs:{"type":"danger","disabled":_vm.isCounting},on:{"click":_vm.startCountdown}},[_vm._v(" "+_vm._s(_vm.isCounting ? _vm.countdown + '秒' : '获取验证码')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }